import { FacebookConnectSdk } from './_facebookSdk';
import { GoogleConnectSdk } from './_googleSdk';
import { SOCIAL_PROVIDER_TYPE } from '../_constants';
export var getProviderSdk = function getProviderSdk(providerType) {
  if (providerType === SOCIAL_PROVIDER_TYPE.Facebook) {
    return new FacebookConnectSdk();
  } else if (providerType === SOCIAL_PROVIDER_TYPE.Google) {
    return new GoogleConnectSdk();
  } else return null;
};